var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4769 1.43245C12.926 1.32206 11.3286 1.26443 9.69713 1.26443C8.0656 1.26443 6.46822 1.32206 4.91737 1.43245C3.21083 1.55392 1.90531 2.82649 1.82823 4.37599C1.70918 6.76912 1.64648 9.25341 1.64648 11.8013C1.64648 14.3492 1.70918 16.8335 1.82823 19.2267C1.90531 20.7762 3.21084 22.0487 4.91737 22.1702C6.46822 22.2806 8.0656 22.3382 9.69713 22.3382C11.3286 22.3382 12.926 22.2806 14.4769 22.1702C16.1834 22.0487 17.4889 20.7762 17.566 19.2267C17.6085 18.3728 17.6438 17.5074 17.6716 16.6316V6.97114C17.6438 6.09532 17.6085 5.22985 17.566 4.37599C17.4889 2.82648 16.1834 1.55392 14.4769 1.43245Z",
    fill: "#D0FF7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2955 11.8014C13.2955 12.6371 13.1784 13.8136 13.0577 14.8048C12.9346 15.8151 11.9237 16.4623 10.992 16.0527C9.28642 15.3028 7.71439 14.1905 6.61414 12.5729C6.29721 12.1069 6.29719 11.4958 6.6141 11.0298C7.71426 9.41214 9.28633 8.29984 10.9919 7.55005C11.9236 7.14048 12.9344 7.78755 13.0576 8.79781C13.1784 9.78911 13.2955 10.9656 13.2955 11.8014Z",
    fill: "#D0FF7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2955 11.8014C13.2955 12.6371 13.1784 13.8136 13.0577 14.8048C12.9346 15.8151 11.9237 16.4623 10.992 16.0527C9.28642 15.3028 7.71439 14.1905 6.61414 12.5729C6.29721 12.1069 6.29719 11.4958 6.6141 11.0298C7.71426 9.41214 9.28633 8.29984 10.9919 7.55005C11.9236 7.14048 12.9344 7.78755 13.0576 8.79781C13.1784 9.78911 13.2955 10.9656 13.2955 11.8014Z",
    stroke: "#0F121D",
    strokeWidth: 2.52886,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6716 6.97114C17.6438 6.09532 17.6085 5.22985 17.566 4.37599C17.4889 2.82648 16.1834 1.55392 14.4769 1.43245C12.926 1.32206 11.3286 1.26443 9.69713 1.26443C8.0656 1.26443 6.46822 1.32206 4.91737 1.43245C3.21083 1.55392 1.90531 2.82649 1.82823 4.37599C1.70918 6.76912 1.64648 9.25341 1.64648 11.8013C1.64648 14.3492 1.70918 16.8335 1.82823 19.2267C1.90531 20.7762 3.21084 22.0487 4.91737 22.1702C6.46822 22.2806 8.0656 22.3382 9.69713 22.3382C11.3286 22.3382 12.926 22.2806 14.4769 22.1702C16.1834 22.0487 17.4889 20.7762 17.566 19.2267C17.6085 18.3728 17.6438 17.5074 17.6716 16.6316",
    stroke: "#0F121D",
    strokeWidth: 2.52886,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.956 11.8013L13.2957 11.8013",
    stroke: "#0F121D",
    strokeWidth: 2.52886,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftLogin);
export default __webpack_public_path__ + "static/media/arrow-left-login.225c12d6f0e7db52b644ddf90a3d2527.svg";
export { ForwardRef as ReactComponent };